import DealerAccountRequestFormReducer from "@aus/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormReducer";
import DealerAccountRequestFormState from "@aus/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormState";
import DefaultToOneTimeShipToReducer from "@aus/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToReducer";
import DefaultToOneTimeShipToState from "@aus/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToState";
import BypassAddressValidationReducer from "@aus/Store/Pages/CheckoutShipping/BypassAddressValidationReducer";
import BypassAddressValidationState from "@aus/Store/Pages/CheckoutShipping/BypassAddressValidationState";
import HeaderReducer from "@aus/Store/Pages/Header/HeaderReducer";
import HeaderState from "@aus/Store/Pages/Header/HeaderState";
import workOrderHistoryPageReducer from "@aus/Store/Pages/WorkOrderHistory/WorkOrderHistoryReducer";
import WorkOrderHistoryState from "@aus/Store/Pages/WorkOrderHistory/WorkOrderHistoryState";
import { AirmarAnalyticsSettingsState } from "@aus/Store/Reducer/AirmarAnalyticsSettingsReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type AusState = {
    airmarAnalyticsSettings: AirmarAnalyticsSettingsState;
    dealerAccountRequestForm: DealerAccountRequestFormState;
    workOrderHistoryPageReducer: WorkOrderHistoryState;
    headerPage: HeaderState;
    updateByPassAddressValidation: BypassAddressValidationState;
    defaultOneTimeShipTo: DefaultToOneTimeShipToState;
} & ApplicationState;

(reducers as any).workOrderHistoryPageReducer = workOrderHistoryPageReducer;
(reducers as any).dealerAccountRequestForm = DealerAccountRequestFormReducer;
(reducers as any).headerPage = HeaderReducer;
(reducers as any).updateByPassAddressValidation = BypassAddressValidationReducer;
(reducers as any).defaultOneTimeShipTo = DefaultToOneTimeShipToReducer;
type Reducers = typeof reducers;

export type AusActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
